import { DiscountEntry } from 'src/entities/volume-discount/Discounts';
import VolumeDiscount from 'src/entities/volume-discount/VolumeDiscount';

export default class CalculatedVolumeDiscount {
    volumeDiscount: VolumeDiscount;
    quantity: number;
    totalPrice: number;
    currencyIso: string;

    constructor(volumeDiscount: VolumeDiscount, quantity: number, totalPrice: number, currencyIso: string) {
        this.volumeDiscount = volumeDiscount;
        this.quantity = quantity;
        this.totalPrice = totalPrice;
        this.currencyIso = currencyIso;
    }

    /**
     * Returns the current active discount if available
     */
    public get currentDiscount(): DiscountEntry | undefined {
        return this.volumeDiscount.getDiscountByQuantity(this.quantity);
    }

    /**
     * Returns the current active plux extra quantity discount if available
     */
    public getCurrentDiscountValueWithExtraQuantity(extraQuantity = 0): number {
        const discount = this.volumeDiscount.getDiscountByQuantity(this.quantity + extraQuantity);

        if (discount) return this.totalPrice * discount.value;
        return 0;
    }

    public get nextDiscount(): DiscountEntry | undefined {
        return this.volumeDiscount.getNextApplicableDiscount(this.quantity);
    }

    /**
     * Returns the current active discount in percentage
     */
    public get currentDiscountNormalized(): number {
        const discount = this.currentDiscount;
        if (discount) return discount.value;
        return 0;
    }

    /**
     * Returns the current active discount amount (absolute value)
     */
    public get currentDiscountValue(): number {
        const discount = this.currentDiscount;
        if (discount) return this.totalPrice * discount.value;
        return 0;
    }
}
